import React, { useState, useEffect } from 'react';
import * as Constant from '../../../Constant';
import ColorLineHr from '../../atoms/ColorLineHr';
import ColorLineText from '../../atoms/Text/ColorLineText';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(
  createStyles({
    tableStyle: {
      borderWidth: '1px',
      borderColor: '#aaaaaa',
      borderStyle: 'solid',
      background: '#e0e0e0',
      borderCollapse: `collapse`,
      width: '150px',
    },
    tdStyle: {
      borderWidth: '1px',
      borderColor: '#aaaaaa',
      borderStyle: 'solid',
      background: '#e0e0e0',
      paddingLeft: '5px',
    },
    tdCheckStyle: {
      borderWidth: '1px',
      borderColor: '#aaaaaa',
      borderStyle: 'solid',
      background: '#e0e0e0',
      paddingLeft: '5px',
    },
  })
);

const TrendGraphItemHeader: React.FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <table className={classes.tableStyle}>
      <thead>
        <tr>
          <td className={classes.tdCheckStyle}>{t('TrendGraphItemHeader.表示有', '表示有')}</td>
          <td className={classes.tdCheckStyle}>{t('TrendGraphItemHeader.線色', '線色')}</td>
        </tr>
        <tr>
          <td className={classes.tdStyle} colSpan={2}>
            {t('TrendGraphItemHeader.計測種別', '計測種別')}
          </td>
        </tr>
        <tr>
          <td className={classes.tdStyle} colSpan={2}>
            {t('TrendGraphItemHeader.機器番号_機器名称', '機器番号・機器名称')}
          </td>
        </tr>
        <tr>
          <td className={classes.tdStyle} colSpan={2}>
            {t('TrendGraphItemHeader.項目名称', '項目名称')}
          </td>
        </tr>
        <tr>
          <td className={classes.tdStyle}>{t('TrendGraphItemHeader.データ種別', 'データ種別')}</td>
          <td className={classes.tdStyle}>{t('TrendGraphItemHeader.単位', '単位')}</td>
        </tr>
        <tr>
          <td className={classes.tdStyle} colSpan={2}>
            {t('TrendGraphItemHeader.異常種別', '異常種別')}
          </td>
        </tr>
        <tr>
          <td className={classes.tdStyle}>
            {t('TrendGraphItemHeader.軽故障', '軽故障')}
            <ColorLineText width={'20px'} color={Constant.LIGHT_FAULT_LINE_COLOR} height={'2px'} />
          </td>
          <td className={classes.tdStyle}>
            {t('TrendGraphItemHeader.重故障', '重故障')}
            <ColorLineText width={'20px'} color={Constant.SERIOUS_FAULT_LINE_COLOR} height={'2px'} />
          </td>
        </tr>
        <tr>
          <td className={classes.tdCheckStyle} colSpan={2}>
            {t('TrendGraphItemHeader.項目選択', '項目選択')}
          </td>
        </tr>
      </thead>
    </table>
  );
};

export default TrendGraphItemHeader;
